import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { UserProfileForUpdateDto } from '../types';
import { UserKeys } from './user.keys';
import { UserProfileKeys } from './userprofile.keys';

export const updateUserProfile = (id: string | undefined, data: UserProfileForUpdateDto) => {
  if (id === null || undefined) {
    throw new Error('id is required');
  }

  return clients.admin.put(`/userprofiles/${id}`, data).then(() => {});
};

export function useUpdateUserProfile(
  id: string | undefined,
  options?: UseMutationOptions<void, AxiosError, UserProfileForUpdateDto>,
) {
  const queryClient = useQueryClient();

  return useMutation((updatedUser: UserProfileForUpdateDto) => updateUserProfile(id, updatedUser), {
    onSuccess: () => {
      queryClient.invalidateQueries(UserKeys.lists());
      queryClient.invalidateQueries(UserKeys.details());
      queryClient.invalidateQueries(UserProfileKeys.lists());
      queryClient.invalidateQueries(UserProfileKeys.details());
    },
    onError: (error) => {
      console.error(error);
    },
    ...options,
  });
}
